import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { API_URL } from '../global/components/Constants';
import { getCategories } from '../utils/api-services/global';

function NewTopic() {

    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [posting, setPosting] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const session = localStorage.getItem("session");

    useEffect(()=>{
        loadCategories();
    }, []);

    const loadCategories = async () => {
        const data = await getCategories();
        setCategories(data);
    }

    const saveForm = ()=>{

        setErrorMsg("");

        if(category == ""){
            setErrorMsg("Please select category");
            return;
        }

        if(title == ""){
            setErrorMsg("Please enter title");
            return;
        }

        if(description == ""){
            setErrorMsg("Please enter description");
            return;
        }
    
        setPosting(true);
    
        const formData = new FormData();
        formData.append('category', category);
        formData.append('title', title);
        formData.append('description', description);

        axios({
            method: "post",
            url: API_URL + "topic/save_topic",
            data: formData,
            headers: { Authorization: `Bearer ${session}`, "Content-Type": "multipart/form-data" },
            processData: false,
            contentType: false,
            mimeType: "multipart/form-data",
            withCredentials: true
        })
        .then(function (response) {
            const obj = response.data;
            if(obj.Success){
                window.location = `/topic/edit/${obj.Data.Slug}`;
            }else{
                setErrorMsg(obj.Message);
                setPosting(false);
            }
        })
        .catch(function (response) {
          setErrorMsg("Posting Error!");
          setPosting(false);
        });
    }


    const styles = {
        page:{
            paddingTop: 40
        },
        form:{
            background: '#fff',
            padding:'10px 15px',
            borderRadius: 10,
            border: "1px solid #ccc",
            marginBottom: 20
        },
        title: {
            color: '#666',
            marginBottom:20,
            fontSize: 18
        },
        label:{
            color: "#aaa",
            fontSize: 14,
            fontWeight: 500
        },
        errorMsg: {
            color: '#990000',
            fontSize: 16,
        },
    }

    return (
        <div style={styles.page}>
        <div className='container'>
            <div className='row'>
                <div className='col-md-3'></div>
                <div className='col-md-6'>
                    <h4 style={styles.title}>Create a new topic</h4>
                    <div style={styles.form}>

                        
                    <div className="form-group">
                            <label style={styles.label}>Category</label>
                            <select value={category} onChange={e => setCategory(e.target.value)} className="form-control">
                                <option key={0} value={""}>- Select Category -</option>
                                {categories.map(itm=>(
                                    <option key={itm.Id} value={itm.Slug}>{itm.Name}</option>
                                ))}
                            </select>
                        </div>
                        
                        <div className="form-group">
                            <label style={styles.label}>Title</label>
                            <input type="text" value={title} onChange={e => setTitle(e.target.value)} className="form-control" placeholder="Enter topic title" />
                        </div>

                        <div className="form-group">
                            <label style={styles.label}>Description</label>
                            <textarea value={description} onChange={e => setDescription(e.target.value)} className="form-control" placeholder="Enter short description"></textarea>
                        </div>

                        {errorMsg != "" && 
                            <div style={styles.errorMsg} className="form-group">{errorMsg}</div>
                        }

                        <div className="form-group">
                            <button onClick={saveForm} className='btn btn-primary'>Continue</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}

export default NewTopic;